export default __webpack_public_path__ + "static/media/HandIcon.8d37a9ee.png";